import _range from 'lodash/range'

import {
  getEnumValuesFromPipelineSchema,
  getMinMaxSchemaValue,
} from '@flows/configs/shared/schemaUtils'
import { BaseSchema_PetHealthV1GetsafeDe as schema } from '@flows/insurance/schemas'

const PET_SCHEMA_VALUES = {
  petMaxAge: getMinMaxSchemaValue(schema.shape.pet_age_at_contract_start.innerType(), 'max'),
}

const deductiblesOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.deductible_percentage
)
export const PET_CONSTANTS = {
  petAgeOptions: _range(PET_SCHEMA_VALUES.petMaxAge + 1),
  unknownOption: 'unknown',
  deductibleOptions: deductiblesOptionsFromSchema,
  helperChippedOptions: ['yes', 'yes_later', 'no'] as const,
}
